import { useState, useMemo, useEffect, useRef } from "react";
import { Badge, Row, Col, Form, Modal, Button, Tab, Tabs, Table } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, } from '@fortawesome/free-solid-svg-icons';
import ReactQuill from 'react-quill';

import gray_pencil from '../../assets/images/gray_pencil.svg';
import gray_star from '../../assets/images/gray_star.svg';
import { ReactComponent as EditIcon } from '../../assets/images/gray_pencil.svg';
import { ReactComponent as StarIcon } from '../../assets/images/gray_star.svg';
import { ReactComponent as TrashIcon } from '../../assets/images/gray_trash.svg';
import { ReactComponent as SaveIcon } from "../../assets/images/save.svg";
import reset_icon from '../../assets/images/reset_icon.svg';
import gray_trash from '../../assets/images/gray_trash.svg';
import send from '../../assets/images/send.svg';
import attachment from '../../assets/images/attachment.svg';
import gallary from '../../assets/images/gallary.svg';
import { CallApi } from "./CommonFunctions";
import { COMMENTDELETE, COMMENTSAVE, SAVEATTACHMENTS } from "../../Utils/conts";
import { toast } from "react-toastify";
import ConfModal from "./ConfModal";
import Trash from '../../assets/images/gray_delete.svg';
import { DownloadImage } from "./DownloadImage";

export const Remarks = ({ propData, onReload, onEdit }) => {

    // IMAGE UPLOAD START

    const [modalConf, setModalConf] = useState(false);
    const [deleteSec, setDeleteSec] = useState('');


    const handleDelete = (dta) => {
        setModalConf(true)
        setDeleteSec(dta)
    }

    const handleConfDelete = () => {
        const cmtDel = () => {
            CallApi({
                endPoint: COMMENTDELETE,
                payload: { comment_id: deleteSec.comment_id, },
                onSuccess: (res) => {
                    const resCode = res.data.response_code;
                    if (resCode === 200) {
                        toast.success(res.data.response_msg);
                        onReload()
                        setModalConf(false)
                    } else {
                        toast.error(res.data.response_msg);
                    }
                },
                onError: (msg) => toast.error(msg)
            });
        }
        if (deleteSec.attachments.length) {
            const ids = deleteSec.attachments.map(a => ({attachment_id: a.id, attachment_type: a.attachment_type}))
            CallApi({
                endPoint: 'attachment-delete',
                payload: { attachment_ids: ids },
                onSuccess: (res) => {
                    if (res.data.response_code == 200) {
                        cmtDel()
                    } else {
                        toast.error(res.data.response_msg);
                    }
                },
                onError: (msg) => toast.error(msg)
            });
        } else {
            cmtDel()
        }
    }

    const handleImportant = (details) => {
        console.log('details', details);
        CallApi({
            endPoint: 'comment-edit',
            payload: { comment_id: details?.comment_id, message: details?.message, bookmark: !details?.bookmark || details?.bookmark === 0 ? 1 : 0 },
            onSuccess: (res) => {
                const resCode = res.data.response_code;
                if (resCode === 200) {
                    toast.success(res.data.response_msg);
                    onReload()
                } else {
                    toast.error(res.data.response_msg);
                }
            },
            onError: (msg) => toast.error(msg)
        });
    }
    const handleDownload = (imageUrl, imageName) => {
        DownloadImage(imageUrl, imageName)
    }

    return (
        <>
            {modalConf &&
                <ConfModal
                    header={`Delete Remarks`}
                    subHeader={`Are you sure you want to delete this Remark?`}
                    modalConf={() => handleConfDelete()}
                    closeModal={() => setModalConf(false)}
                    primaryBtn='Delete'
                    secondaryBtn='Cancel'
                />
            }

            {/* <div className="d-flex align-items-center top_search">
                <Form.Control
                    type="text"
                    placeholder="Search File Name"
                    className="search-input"
                />
                <span className='reset_btn'><img src={reset_icon} alt='reset_icon' /></span>
            </div> */}
            {propData?.comments?.length === 0 && <div className="text-center no_item_text">No remarks added yet.</div>}
            {propData?.comments?.map((cmt, index) => (
                <>
                    <div className='remark_box' key={`${cmt?.created_by}_${index}`}>
                        <div className="remark-header">
                            <div className="remark-title">
                                <span>{cmt?.created_by}</span>
                                <span className="remark-time">{cmt?.created_at.slice(0, 16)}</span>
                            </div>

                            <div className="remark-actions">
                                {/* <img src={gray_pencil} alt='gray_pencil' onClick={() => onEdit(cmt)} /> */}
                                {/* <img src={gray_trash} alt='gray_trash' onClick={() => handleDelete(cmt)} /> */}
                                {/* <img src={gray_star} alt='gray_star' className='starred' onClick={() => handleImportant(cmt)} /> */}
                                <EditIcon onClick={() => onEdit(cmt)} />
                                <TrashIcon onClick={() => handleDelete(cmt)} />
                                <StarIcon className={cmt?.bookmark === 1 ? 'starred' : ''} onClick={() => handleImportant(cmt)} />
                            </div>
                        </div>
                        <div className="remark-text">
                            <p>{cmt?.message}</p>
                        </div>
                        <div className="remark-files">
                            {cmt?.attachments?.length ?
                                <>
                                    {cmt?.attachments?.map((att, index) => (
                                        <div variant="" key={att.file_name + '_' + index}>
                                            <FontAwesomeIcon icon={faDownload} onClick={() => handleDownload(att.file_path, att.file_name)} />
                                            <p>{att.file_name}</p>
                                        </div>
                                    ))}
                                </>
                                :
                                <></>
                            }
                        </div>
                    </div>
                    <hr />
                </>

            ))}
        </>
    )
}

export const RemarksForm = ({ propInfo, onReload, eData, isModal, }) => {

    console.log('eData', eData);

    const fileInputRef = useRef(null);
    const [files, setFiles] = useState([]);
    const [editFiles, setEditFiles] = useState([]);
    const [base64Files, setBase64Files] = useState([]);
    const [formData, setFormData] = useState({});

    useEffect(() => {
        if (eData) {
            setFormData({ message: eData?.message, comment_id: eData?.comment_id })
            setFiles(eData?.attachments)
        }
    }, [eData])
    const handleDrop = (e) => {
        e.preventDefault();
        const droppedFiles = Array.from(e.dataTransfer.files);
        setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
        getBase64(droppedFiles[0]);

    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDeleteFile = (index, id, type) => {
        const reform = () => {
            setFiles((prevFiles) => {
                const newFiles = [...prevFiles];
                newFiles.splice(index, 1);
                return newFiles;
            });
            // base64Files.splice(index, 1);
            setBase64Files((prevBase64Files) => {
                const newBase64Files = [...prevBase64Files];
                newBase64Files.splice(index, 1);

                // Update local storage
                setFormData((prevFormData) => {
                    const newFormData = { ...prevFormData, base64Files: newBase64Files, files: newBase64Files };
                    return newFormData;
                });

                return newBase64Files;
            });
        }

        if (id) {
            CallApi({
                endPoint: 'attachment-delete',
                payload: { attachment_id: id, attachment_type: type },
                onSuccess: (res) => {
                    if (res.data.response_code == 200) {
                        reform()
                    } else {
                        toast.error(res.data.response_msg);
                    }
                },
                onError: (msg) => toast.error(msg)
            });
        } else {
            reform()
        }

    };

    const handleBrowseFiles = (e) => {
        e.preventDefault();
        fileInputRef.current.click();
    };

    function getBase64(file) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            setBase64Files((prevBase64Files) => [...prevBase64Files, reader.result]);
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }

    const handleFileChange = (e) => {
        const selectedFiles = Array.from(e.target.files);
        const filesWithBase64 = [];
        let filesProcessed = 0;

        // const existingData = JSON.parse(localStorage.getItem(keyType)) || {};
        const existingBase64Files = formData?.base64Files || [];
        const existingFiles = files || [];

        selectedFiles.forEach((file) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                filesWithBase64.push({ file, base64: reader.result, file_name: file.name });
                filesProcessed += 1;
                if (filesProcessed === selectedFiles.length) {
                    const newFiles = filesWithBase64.map((obj) => obj.file);
                    // const newBase64Files = filesWithBase64.map((obj) => obj.base64);
                    const newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }));
                    const mergedBase64Files = [...existingBase64Files, ...newBase64Files];
                    const mergedFiles = [...existingFiles, ...newBase64Files];
                    // setFiles(newFiles);
                    // setFiles((prevFiles) => [...prevFiles, ...newFiles]);
                    setFiles(mergedFiles);
                    setBase64Files(mergedBase64Files);
                    setFormData((prevFormData) => {
                        // const newFormData = { ...prevFormData, files: newFiles, base64Files: mergedBase64Files };
                        const newFormData = { ...prevFormData, files: mergedBase64Files };

                        return newFormData;
                    });
                }
            };
            reader.readAsDataURL(file);
        });
    };
    // IMAGE UPLOAD END

    const handleSubmit = () => {
        // console.log('formData =submit', formData);

        const addComment = () => {
            CallApi({
                endPoint: eData ? 'comment-edit' : COMMENTSAVE,
                payload: { commentable_id: propInfo?.id, commentable_type: propInfo?.attType, ...formData },
                onSuccess: (res) => {
                    const resCode = res.data.response_code;
                    if (resCode === 200) {
                        toast.success(res.data.response_msg);
                        setFormData({})
                        setFiles([])
                        onReload()
                    } else {
                        toast.error(res.data.response_msg);
                    }
                },
                onError: (msg) => toast.error(msg)
            });
        }

        const addAttachment = () => {
            const imageAllData = {
                attachable_id: propInfo?.id,
                attachable_type: propInfo?.attType,
                files: formData?.files,
                is_comment: 1
            };
            CallApi({
                endPoint: SAVEATTACHMENTS,
                payload: imageAllData,
                onSuccess: (res) => {
                    const resCode = res.data.response_code;
                    if (resCode === 200) {
                        addComment()
                    } else {
                        toast.error(res.data.response_msg);
                    }
                },
                onError: (msg) => toast.error(msg)
            });
        }

        if (formData?.files?.length > 0) {
            addAttachment()
        } else {
            addComment()
        }

    }

    const handleDownload = (imageUrl, imageName) => {
        DownloadImage(imageUrl, imageName)
    }

    const handleDload = (file) => {
        const link = document.createElement("a");
        link.href = file.base64;
        link.download = file.file_name || "image.png";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };



    return (
        <div className='new_remarks_dv'>
            {!isModal &&
                <div className='hdr_title'>
                    <h5>New Remarks</h5>
                    <p>Add a new remark to the trip.</p>
                </div>
            }
            <div className='txt_area'>
                {/* <ReactQuill
                            ref={quillRef}
                            value={editorData}
                            onChange={setEditorData}
                            modules={modules}
                            formats={['bold', 'italic', 'underline', 'list', 'image']}
                            placeholder="Write something..."
                            className="txt_area"
                            style={{ padding: '0px' }}
                        /> */}
                <Form.Control
                    as="textarea"
                    placeholder="Leave a comment here"
                    style={{ height: '100%', padding: '0px' }}
                    onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                    value={formData?.message || ''}
                />
            </div>
            {/* {console.log('files', files)}
            {console.log('formData', formData)} */}
            {isModal &&
                <>
                    <div className='d-flex align-items-center mt-2' style={{ gap: '10px' }}>
                        <span><img src={attachment} alt='attachment' onClick={handleBrowseFiles} />
                            <input
                                type="file"
                                ref={fileInputRef}
                                style={{ display: "none" }}
                                accept="image/png,image/jpeg,application/pdf"
                                onChange={handleFileChange}
                                multiple
                            />
                        </span>
                        {/* <span><img src={gallary} alt='gallary' /></span> */}
                    </div>
                    {files?.length > 0 &&
                        <div className="remarks_attch_count">Attachments <span>{files?.length}</span></div>}
                </>
            }
            {files.length > 0 &&
                <div className="attch_item">
                    {files?.map((file, index) => {
                        const fileName = file.name ?? file.file_name;
                        const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                        const extension = fileName?.split(".").pop();
                        return (
                            <>
                                {/* <div key={index} className='img-thumbnail'> */}
                                <div variant="" key={`rForm_${index}`}>{console.log('file', file)}
                                    <FontAwesomeIcon icon={faDownload} onClick={() => handleDload(file)} />
                                    {/* {baseName} */}
                                    {baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 10)}... .${extension}`}
                                    <img src={Trash} className="last-item" onClick={() => handleDeleteFile(index, file.id, file.attachment_type)} />
                                </div>
                            </>
                        )
                    })}
                </div>
            }
            {!isModal &&
                <div className='d-flex align-items-center' style={{ gap: '10px' }}>
                    <button className="email_btn mb-1 me-1" onClick={handleSubmit}><img src={send} alt="cross" />Add Remark</button>
                    <span className="attch_icon"><img src={attachment} alt='attachment' onClick={handleBrowseFiles} />
                        <input
                            type="file"
                            ref={fileInputRef}
                            style={{ display: "none" }}
                            accept="image/png,image/jpeg,application/pdf"
                            onChange={handleFileChange}
                            multiple
                        />
                    </span>
                    {/* <span><img src={gallary} alt='gallary' /></span> */}
                </div>
            }
            {isModal && <button className="email_btn float-end" onClick={handleSubmit}><SaveIcon /> Save Remark</button>}

        </div>
    )
}